import FormField from "@/components/ui/form-field";
import { Dialog } from "radix-ui";
import { Dispatch, FC, SetStateAction } from "react";
import { useRegisterData } from "../../hooks/useRegisterData";
import { ModalStateType } from "../../types";
import {
  ERROR_BUTTON_TEXT_MAP,
  ERROR_TEXT,
  getRegistrationErrorText,
  ProcessingState,
  REGISTER_FORM_FIELDS,
  SUCCESS_TEXT_MAP,
} from "./constants";
import clsx from "clsx";
import { FormProvider } from "react-hook-form";
import S from "../../index.module.scss";
import ApiError from "@/api/ApiError";

interface IRegisterForm {
  setState: Dispatch<SetStateAction<ModalStateType>>;
  state: ProcessingState;
}

const RegisterForm: FC<IRegisterForm> = ({ setState, state }) => {
  const { isPending, isError, isSuccess, methods, lastPayload, handleBackToForm, onSubmit, error } = useRegisterData({
    state,
  });

  if (isSuccess || isError) {
    const successText = SUCCESS_TEXT_MAP[state];
    const errorText =
      state === "register"
        ? getRegistrationErrorText(error instanceof ApiError ? error.status : undefined)
        : ERROR_TEXT;

    return (
      <div className={S.form}>
        <div className={S.processing} aria-live="polite">
          <Dialog.Title className={clsx(S.title, S["title--center"])}>
            {isError ? errorText.title : successText.title}
          </Dialog.Title>

          <p
            className={S.processingSubtitle}
            dangerouslySetInnerHTML={{
              __html: isError ? errorText.subtitle : successText.subtitle(lastPayload?.email || "указанный e-mail"),
            }}
          />

          {!isError && <p className={S.processingHint}>{successText.hint}</p>}

          {isError && (
            <button type="button" className={S.submitButton} onClick={handleBackToForm}>
              {ERROR_BUTTON_TEXT_MAP[state]}
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <FormProvider {...methods}>
      <form className={S.form} onSubmit={onSubmit} noValidate>
        <Dialog.Title className={S.title}>{state === "register" ? "Регистрация" : "Сброс пароля"} </Dialog.Title>
        <div className={S.fields}>
          {REGISTER_FORM_FIELDS.map(field => (
            <FormField key={field.id} field={field} />
          ))}
        </div>

        <button type="submit" className={S.submitButton} disabled={isPending}>
          {state === "register" ? "Зарегистрироваться" : "Сбросить пароль"}
        </button>
        <span className={S.info}>
          Уже есть аккаунт?
          <span className={S.infoButton} onClick={() => setState("login")}>
            Войти
          </span>
        </span>
      </form>
    </FormProvider>
  );
};

export default RegisterForm;
